import * as yup from 'yup';
import type { FormDefinition } from '@gov-design-system-ce/react-form-core';
import {
	getFormDefinition,
	useGovForm,
} from '@gov-design-system-ce/react-form-core';
import type { SearchAllTypesRequestParams } from '@gov-nx/api';
import type { Optional } from '@gov-nx/core/types';
import type {
	SearchAllTypesFilterForm,
	SearchAllTypesListFilter,
} from './context.types';

export function FormInstance(): FormDefinition<SearchAllTypesFilterForm> {
	const formSchema = yup
		.object({
			search: yup.string().nullable(),
		})
		.required();

	const formMethods = useGovForm<SearchAllTypesFilterForm>({
		formSchema,
		defaultValues: {
			search: null,
		},
	});

	return getFormDefinition({ formMethods, formSchema });
}

export const prepareSubmitData = (
	filter: SearchAllTypesListFilter,
	search: Optional<string>,
	app: string,
	env: string,
	designations?: SearchAllTypesRequestParams['designations']
): SearchAllTypesRequestParams => ({
	search: search && search.length > 2 ? search : undefined,
	app,
	env,
	locale: filter.language,
	designations,
});
